import {http} from 'utils/http';

// types

export type AvailableLanguage = string;

/**
 * TODO: move to libraries.
 */
export interface GenericOutSuccess<T> {
	error: boolean;
	message: string;
	at: Date;
	data: T;
}

// ROUTES

export const apiUpdateLanguageRoute = () => '/users/me/language/';

// APIS

export const apiUpdateLanguage = (language: AvailableLanguage) => {
	return http.put<GenericOutSuccess<string>>(apiUpdateLanguageRoute(), {
		preferred_language: language as string
	});
};
